import GrowthAndSuccess2 from '@/assets/images/GrowthAndSuccess2.png';
import { styled } from '@mui/material';
import React from 'react';
const StyledImage = styled('img')(({ theme }) => ({
    position: 'fixed',
    right: 0,
    bottom: -25,
    width: '320px',
    zIndex: theme.zIndex.drawer + 150,
    pointerEvents: 'none',
    [theme.breakpoints.down(768)]: {
        display: 'none',
    },
}));
export const StepperSideImage = () => {
    return React.createElement(StyledImage, { src: GrowthAndSuccess2, alt: "Growth and success illustration 2" });
};
